<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead
          tr
            th(style="width: 80px;")
              div {{ $t('ui.time') }}
            th(style="width: 450px;")
              div {{ $t('ui.event') }}
            th(style="width: 40px;")
              div.text-center 1:0
            th(style="width: 40px;")
              div.text-center 0:1
            th(style="width: 40px;")
              div.text-center 2:0
            th(style="width: 40px;")
              div.text-center 0:2
            th(style="width: 40px;")
              div.text-center 2:1
            th(style="width: 40px;")
              div.text-center 1:2
            th(style="width: 40px;")
              div.text-center 3:0
            th(style="width: 40px;")
              div.text-center 0:3
            th(style="width: 40px;")
              div.text-center 3:1
            th(style="width: 40px;")
              div.text-center 1:3
            th(style="width: 40px;")
              div.text-center 3:2
            th(style="width: 40px;")
              div.text-center 2:3
            th(style="width: 40px;")
              div.text-center 4:0
            th(style="width: 40px;")
              div.text-center 0:4
            th(style="width: 40px;")
              div.text-center 4:1
            th(style="width: 40px;")
              div.text-center 1:4
            th(style="width: 40px;")
              div.text-center 4:2
            th(style="width: 40px;")
              div.text-center 2:4
            th(style="width: 40px;")
              div.text-center 4:3
            th(style="width: 40px;")
              div.text-center 3:4
            th(style="width: 40px;")
              div.text-center 0:0
            th(style="width: 40px;")
              div.text-center 1:1
            th(style="width: 40px;")
              div.text-center 2:2
            th(style="width: 40px;")
              div.text-center 3:3
            th(style="width: 40px;")
              div.text-center 4:4
            th(style="width: 40px;")
              div.text-center AOS
            //- th(v-for="(scoreAlias, index) in getScoreHeader(cacheList[0], betType, true)")
            //-   div.text-center {{ scoreAlias }}
        tbody(v-for="(item, index) in cacheList")#scrollArea.clusterize-scroll
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '1x0_blink'] }") {{ item[betType + '1x0'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '0x1_blink'] }") {{ item[betType + '0x1'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '2x0_blink'] }") {{ item[betType + '2x0'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '0x2_blink'] }") {{ item[betType + '0x2'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '2x1_blink'] }") {{ item[betType + '2x1'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '1x2_blink'] }") {{ item[betType + '1x2'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '3x0_blink'] }") {{ item[betType + '3x0'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '0x3_blink'] }") {{ item[betType + '0x3'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '3x1_blink'] }") {{ item[betType + '3x1'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '1x3_blink'] }") {{ item[betType + '1x3'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '3x2_blink'] }") {{ item[betType + '3x2'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '2x3_blink'] }") {{ item[betType + '2x3'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '4x0_blink'] }") {{ item[betType + '4x0'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '0x4_blink'] }") {{ item[betType + '0x4'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '4x1_blink'] }") {{ item[betType + '4x1'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '1x4_blink'] }") {{ item[betType + '1x4'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '4x2_blink'] }") {{ item[betType + '4x2'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '2x4_blink'] }") {{ item[betType + '2x4'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '4x3_blink'] }") {{ item[betType + '4x3'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '3x4_blink'] }") {{ item[betType + '3x4'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '0x0_blink'] }") {{ item[betType + '0x0'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '1x1_blink'] }") {{ item[betType + '1x1'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '2x2_blink'] }") {{ item[betType + '2x2'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '3x3_blink'] }") {{ item[betType + '3x3'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + '4x4_blink'] }") {{ item[betType + '4x4'] }}
            td.text-center(style="width: 40px;")
              div(:class="{ 'up' : item[betType + 'aos_blink'] }") {{ item[betType + 'aos'] }}
            //- td.text-center(v-for="(score, index) in getScoreHeader(cacheList[0], betType, false)" style="width: 40px;")
            //-   div(:class="{ 'up' : item[score + '_blink'] }") {{ item[score] }}
</template>
<script>
import _ from "lodash";

export default {
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      groupList: []
    };
  },
  methods: {
    getScoreHeader: function(obj, betType, isAlias) {
      var groupList = [];
      var value = "";

      if (obj == null) return groupList;

      for (var prop in obj) {
        if (prop.includes(betType) && !prop.endsWith("_blink")) {
          if (isAlias) {
            var re = new RegExp(betType, "g");
            value = prop.replace(re, "").replace("x", ":");
          } else value = prop;
          groupList.push(value);
        }
      }

      if (groupList.length <= 0) return [];

      return groupList;
    },
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>